import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { UiService } from '../../../core/services/core.ui.service';

@Injectable()
export class ChecksDetailService {

  private helpMap = {
    'Commits': 'https://blog.gforgegroup.com/2023/01/26/health-checks-commits/',
    'Tasks': 'https://blog.gforgegroup.com/2023/01/27/health-checks-tasks/'
  };

  constructor(private uiService: UiService) {}

  getTotals(list: any[]): any {
    const byLevel = _.groupBy(list, 'level');
    return Object.keys(byLevel).reduce((carry, key) => {
      carry[key] = byLevel[key].length;
      return carry;
    }, {});
  }

  getSubtree(list: any[], groupName: string): any {
    const byGroup = _.groupBy(_.values(list), groupName);
    return _.reduce(
      byGroup,
      (carry, items, key) => {
        const item = {
          totals: this.getTotals(items),
          items: items
        };
        item[groupName] = key;
        carry.push(item);
        return carry;
      },
      []
    );
  }

  transformDetails(details: any, unixName: string): any {
    const list = this.transformChecks(
      _.get(details, 'data', []), unixName
    );
    const byCat = this.addCategoryLinks(
      this.getSubtree(list, 'category')
    );
    return {
      totals: this.getTotals(list),
      items: _.reduce(
        byCat,
        (carry, item: any) => {
          item.items = this.getSubtree(item.items, 'name');
          return carry;
        },
        byCat
      )
    };
  }

  addCategoryLinks(subtree: any): any {
    return _.map(
      subtree,
      (s) => {
        s.helpUrl = _.get(this.helpMap, s.category);
        return s;
      }
    );
  }

  transformChecks(items: any[], unixName: string): any {
    return _.map(
      items,
      (item) => {
        switch (item.level) {
          case 2:
            item.glyph = 'glyphicon-exclamation-sign';
            item.class = 'list-group-item-danger';
            break;
          case 1:
            item.glyph = 'glyphicon-question-sign';
            item.class = 'list-group-item-warning';
            break;
          case 0:
            item.glyph = 'glyphicon-ok-sign';
            item.class = 'list-group-item-success';
            break;
          default:
            item.glyph = 'glyphicon-ban-circle';
            item.class = 'text-muted';
            break;
        };
        const href = this.uiService.state.getUrlForSectionRefId(
          item.link.section, _.get(item.link, 'ref_id', item.link.refId), unixName
        );
        item.href = !_.isEmpty(href) ? href : null;
        return item;
      }
    );
  }
}
